import uuid from "uuid";
import EventManager from "../../../store/sqftEventManager";
import WaterfallSegment from "../shapeParts/models/waterfallSegment";
import {WATERFALL_OVERLAY_TYPE, WATERFALL_SHAPES_KEY, WATERFALL_SHAPES_NAME} from "../../../../../constants";

export default class WaterfallOverlay {
  id;
  sectionIndex;
  line;
  type; // WATERFALL_OVERLAY_TYPE
  state = {
  };
  design = {
  };
  segments = []; // array of WaterfallSegments

  constructor(line, sectionIndex, importData, type = WATERFALL_OVERLAY_TYPE.waterfall) {
    this.line = line;
    this.sectionIndex = sectionIndex;
    this.id = uuid();
    this.type = type;
    if (importData) {
      this.importData(importData)
    } else {
      switch (type) {
        case WATERFALL_OVERLAY_TYPE.peninsulaUnderwrap:
          this.createPeninsulaUnderwrapSections();
          break;
        case WATERFALL_OVERLAY_TYPE.waterfall:
        default:
          this.createWaterfallSections();
          break;
      }
    }
  }

  getSegments = () => { return this.segments; }
  getParent = () => { return this.line; }
  setSegments = (value) => { this.segments = value; }
  addSegment = (segment) => { this.segments.push(segment); }

  destroy = (protect) => {
    if (!protect) {
      EventManager.removeEvent(this);
      this.segments.forEach((segment) => {
        segment.destroy();
      });
    }
  };

  initEvents = () => {
  };

  deregisterEvents = () => {
    EventManager.removeEvent(this);
  };

  reInitEvents = () => {
    this.initEvents();
  };

  export = () => {
    return this.exportData();
  }

  exportData = () => {
    return {
      id: this.id,
      lineId: this.line.id,
      state: this.state,
      type: this.type,
      segments: this.segments.map((segment) => {
        return segment.exportData()
      }),
    }
  };

  importData = (importData) => {
    this.state = importData.state;
    for (const segmentData of importData.segments) {
      this.addSegment(new WaterfallSegment(
        segmentData.key,
        segmentData.name,
        segmentData.length,
        segmentData.height,
        segmentData.thickness,
        this,
        segmentData.isDisabled
      ));
    }
  };

  createWaterfallSections = () => {
    const segments = [
      new WaterfallSegment(WATERFALL_SHAPES_KEY.waterfall, WATERFALL_SHAPES_NAME.waterfall, this.line.getLineLength(), 36, 1.5, this),
      new WaterfallSegment(WATERFALL_SHAPES_KEY.cabinetReturn, WATERFALL_SHAPES_NAME.cabinetReturn,4, 36, 1.5, this, true),
      new WaterfallSegment(WATERFALL_SHAPES_KEY.overhangReturn, WATERFALL_SHAPES_NAME.overhangReturn,20, 36, 1.5,  this, true),
      new WaterfallSegment(WATERFALL_SHAPES_KEY.underlayment, WATERFALL_SHAPES_NAME.underlayment, this.line.getLineLength(), 36, 1.5,  this, true),
    ];
    this.setSegments(segments);
  }

  createPeninsulaUnderwrapSections = () => {
    const segments = [
      new WaterfallSegment(WATERFALL_SHAPES_KEY.peninsulaUnderwrap, WATERFALL_SHAPES_NAME.peninsulaUnderwrap, this.line.getLineLength(), 36, 1.5, this, false),
    ];
    this.setSegments(segments);
  }

  getArea = () => {
    return this.segments.reduce((sum, segment) => sum + segment.getArea(), 0)
  }
}
